<template>
  <VContainer class="flex flex-col p-4">
    <PageHeader :show-button="t('Back')" @back="router.back()">
      {{ t('Patient Data') }}
    </PageHeader>
    <PatientDataSettingsForm />
  </VContainer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import PageHeader from '@/components/page/PageHeader.vue'
import PatientDataSettingsForm from '@/components/patient/components/molecules/PatientDataSettingsForm.vue'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const router = useRouter()
</script>
